module.exports = __webpack_public_path__ + "static/media/gembah-logoblack.2695001f.png";